import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LITE_LOGIN_ROUTES } from './lite-login.routes';
import { LiteLoginAccessesListComponent } from './lite-login-accesses-list/lite-login-accesses-list.component';
import { LiteLoginAccessesFormComponent } from './lite-login-accesses-form/lite-login-accesses-form.component';


@NgModule({
  imports: [
    RouterModule.forChild(LITE_LOGIN_ROUTES),
    SharedModule
  ],
  declarations: [
    LiteLoginAccessesListComponent,
    LiteLoginAccessesFormComponent,
  ],
  providers: [
  ]
})
export class LiteLoginModule {
}
